// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_needAttentionChip__0yvKN {
  white-space: inherit;
  height: auto;
  padding: 6px;
  border-radius: 8px;
  margin-top: 12px !important;
}

.popup_needAttentionChip__0yvKN > span {
  white-space: inherit;
  text-align: center;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/manage-restaurants/list/map/popup/popup.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".needAttentionChip {\n  white-space: inherit;\n  height: auto;\n  padding: 6px;\n  border-radius: 8px;\n  margin-top: 12px !important;\n}\n\n.needAttentionChip > span {\n  white-space: inherit;\n  text-align: center;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"needAttentionChip": `popup_needAttentionChip__0yvKN`
};
export default ___CSS_LOADER_EXPORT___;
